<div class="cookie-consent" *ngIf="visible && !dialogOpen && !onAdmin" role="dialog" aria-live="polite" aria-labelledby="cc-text">
  <p class="cc-text" id="cc-text">{{ 'cookieConsent.body' | translate }}</p>

  <div class="cc-manage" *ngIf="managing">
    <label class="cc-opt">
      <input type="checkbox" [(ngModel)]="analytics" name="ccAnalytics" />
      <span>
        <strong>{{ 'cookieConsent.analyticsLabel' | translate }}</strong>
        <small>{{ 'cookieConsent.analyticsDesc' | translate }}</small>
      </span>
    </label>
    <label class="cc-opt">
      <input type="checkbox" [(ngModel)]="marketing" name="ccMarketing" />
      <span>
        <strong>{{ 'cookieConsent.marketingLabel' | translate }}</strong>
        <small>{{ 'cookieConsent.marketingDesc' | translate }}</small>
      </span>
    </label>
  </div>

  <div class="cc-actions">
    <button type="button" class="cc-btn cc-decline" (click)="decline()">
      {{ 'cookieConsent.decline' | translate }}
    </button>
    <ng-container *ngIf="!managing; else saveBtn">
      <button type="button" class="cc-btn cc-decline" (click)="manage()">
        {{ 'cookieConsent.manage' | translate }}
      </button>
      <button type="button" class="cc-btn cc-accept" (click)="accept()">
        {{ 'cookieConsent.accept' | translate }}
      </button>
    </ng-container>
    <ng-template #saveBtn>
      <button type="button" class="cc-btn cc-accept" (click)="save()">
        {{ 'cookieConsent.save' | translate }}
      </button>
    </ng-template>
  </div>
</div>
